import { useEffect } from "react";
import type { MetaDataPropertyType } from "types/metaDataPropertyTypes";
import type { PropertyCriteria } from "types/qbank/propertyCriteria";
import { SearchOperator } from "types/qbank/searchOperator";
import { Input } from "components/ui";

export default function Keywords(props: {
  propertyType: MetaDataPropertyType;
  setCriteria: (propertyCriteria: PropertyCriteria) => void;
  setValue: (value: string) => void;
  value: string;
}) {
  useEffect(() => {

      props.setCriteria({
        id: props.propertyType.id,
        systemName: props.propertyType.systemname,
        operator: SearchOperator.CONTAINS_ANY,
        value: props.value !== undefined && props.value.length
        ? Array.isArray(props.value)
        ? props.value.split(",").map((val) => val.trim())
        : props.value
      : undefined,
        label: props.propertyType.name,
      });
    // eslint-disable-next-line
  }, [props.value]);

  return (
    <div className="field" data-testid="keywords">
      <label className="label">{props.propertyType.name}</label>

      <div className="control">
        <Input
          fullwidth
          value={props.value ?? ""}
          onChange={(e) => props.setValue(e.target.value)}
        />
      </div>
    </div>
  );
}
